import { Amplitude } from '@seede/amplitude';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const apiKey = '9313d5a306deac9e358936b74f26754a';

  Amplitude.init({
    apiKey,
    appName: 'landing-page',
    env: config.public.NODE_ENV || 'production',
    enabled: true,
    debug: config.public.NODE_ENV !== 'production',
  });
});
